export default {
      id: "skipNext-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#skipNext-usage",
      toString: function () {
        return this.url;
      }
    }